'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'

export const PlusMinusInput = styled.div`
  border-radius: 5px;
  display: flex;
`

export const InputMinus = styled.div<{$disabled: boolean}>`
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  background: ${theme.colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: ${props => (props.$disabled && 'not-allowed') || 'pointer'};

  height: 45px;
  width: 45px;

  font-weight: 450;

  color: ${theme.colors.dark};

  &:hover {
    background: ${theme.colors.bgContent};
    border: solid 1px ${theme.colors.primary};
    color: ${theme.colors.text};
  }
`

export const InputPlus = styled(InputMinus)`
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`

export const InputCount = styled(InputMinus)`
  border-radius: unset;

  cursor: inherit;

  &:hover {
    background: ${theme.colors.primary};
    border: inherit;
    color: inherit;
  }
`
